<template>
  <el-form
    class="search_form"
    inline
    size="small"
    label-suffix=":"
    label-position="right"
  >
    <el-form-item label="关键词">
      <el-input
        class="filter"
        placeholder="请输入关键词"
        v-model="searchForm.keyword"
        clearable
        @change="changeSearch"
      ></el-input>
    </el-form-item>
    <el-form-item label="品牌">
      <el-input
        class="filter"
        placeholder="请输入品牌名"
        v-model="searchForm.brandName"
        clearable
        @change="changeSearch"
      ></el-input>
    </el-form-item>
    <el-form-item label="企业">
      <el-select
        class="query_select"
        clearable
        v-model="searchForm.enterpriseName"
        @change="changeSearch"
      >
        <el-option
          v-for="e in enterpriseList"
          :key="e.enterpriseId"
          :label="e.enterpriseName"
          :value="e.enterpriseName"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="状态">
      <el-select
        class="query_select"
        clearable
        v-model="searchForm.status"
        @change="changeSearch"
      >
        <el-option
          v-for="e in statusList"
          :key="e.value"
          :label="e.label"
          :value="e.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" icon="el-icon-plus" @click="add"
        >新增品牌</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    enterpriseList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchForm: {
        enterpriseName: "",
        brandName: "",
        keyword: "",
        status: "",
      },

      statusList: [
        {
          vlaue: "all",
          label: "不限",
        },
        {
          value: 0, // 0代表正常运行
          label: "正常",
        },
        {
          value: 1,
          label: "暂停",
        },
      ],
    };
  },
  computed: {
    computeSearch() {
      let val = { ...this.searchForm };
      if (val.status === "all") {
        delete val.status;
      }
      Object.keys(val).forEach((key) => {
        if (!val[key] && val[key] !== 0) delete val[key];
      });
      return val;
    },
  },
  mounted() {},
  methods: {
    changeSearch() {
      this.$emit("search-change", this.computeSearch);
    },
    // 点击新增
    add() {
      //   console.log("您点击了新增账号");
      this.$emit("add-keyword");
    },
  },
};
</script>

<style lang="scss">
.search_form {
  display: flex;
  justify-content: end;

  .query_select {
    width: 100px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/views/brandWord/keywordSearch.vue